import isEmail from 'validator/lib/isEmail';
import { textValidator } from './textValidator';
import { Validator } from './types';

export function emailValidator(options?: {
  trim?: boolean;
  required?: boolean | string;
  msg?: string;
}): Validator {
  return textValidator({
    ...options,
    valid: s =>
      isEmail(s)
        ? { type: 'valid' }
        : { type: 'invalid', msg: options?.msg ?? 'Invalid email format' },
  });
}
